/* globals app */

import $ from 'jquery';
import Backbone from 'backbone';

import LoadingView from 'core/views/loading';


export default Backbone.View.extend({
  daily_tracker: null,

  // Application Constructor
  initialize: function () {
    _.bindAll.apply(_, [this].concat(_.functions(this)));

    this.loginContent = $('#login-content');
    this.loadingView = new LoadingView({ el: $('body') });
    this.onLoginPage = this.loginContent.length !== 0;
  },

  render: function () {
    app.bindEvents();
  },

  // Bind Event Listeners
  //
  // Bind any events that are required on startup. Common events are:
  // 'load', 'deviceready', 'offline', and 'online'.
  bindEvents: function () {
    if (typeof cordova === 'undefined') {
      console.log('NO CORDOVA!');
      app.onDeviceReady();
    } else {
      document.addEventListener('deviceready', app.onDeviceReady, false);
      console.log('Bound device ready event');
    }
  },

  start_fresh: function () {
    console.log('STARTING FRESH');
    for (var key in window.localStorage) {
      if (Object.prototype.hasOwnProperty.call(window.localStorage, key)) {
        window.localStorage.removeItem(key);
      }
    }
    location.reload();
  },

  user_api_url: function (name) {
    var uri = window.Urls['accounts_api:api_dispatch_list']({
      api_name: API_VERSION,
      resource_name: 'user',
    }) + name + '/' + (AUTH ? '?auth=' + AUTH.auth : '');
    return API_PREFIX + uri;
  },

  check_login: function (registrationId) {
    if (!this.onLoginPage) {
      this.loadingView.hide();
      return;
    }
    var regData = '';
    if (typeof cordova !== 'undefined' && registrationId !== null) {
      regData = '&platform=' + device.platform + '&regid=' + registrationId;
      window.localStorage.setItem('REGISTRATION_ID', registrationId);
    }
    if (window.localStorage.getItem('USERNAME') && window.localStorage.getItem('API_KEY')) {
      console.log('WE ALREADY HAVE THE API_KEY. Update regid');
      if (typeof cordova === 'undefined') {
        app.go_to_next_page();
      } else {
        var userData = 'username=' + encodeURIComponent(window.localStorage.getItem('USERNAME')) +
                    '&api_key=' + encodeURIComponent(window.localStorage.getItem('API_KEY'));
        $.ajax({
          type: 'POST',
          timeout: 5000,
          url: app.user_api_url('update'),
          data: userData + regData,
          success: function (data) {
            app.update_user_data(data);
            console.log('user updated!');
            app.go_to_next_page();
          },
          error: function () {
            if (!parseInt(window.localStorage.getItem('IS_LOGGED_IN'))) {
              app.start_fresh();
            }
          }
        });
      }
    } else {
      app.bind_form(regData);
    }
  },

  bind_form: function (regData) {
    app.loginContent.fadeIn();
    app.hideLoading();
    $('input[type="submit"]', app.login_form).on('click', function (e) {
      e.preventDefault();
      app.showLoading();
      var formData = $('form', app.login_form).serialize() + regData;
      $.ajax({
        type: 'POST',
        timeout: 10000,
        url: app.user_api_url('login'),
        data: formData,
        success: app.login_success,
        error: app.login_error
      });
    });
  },

  set_local_storage_keys: function (obj) {
    Object.keys(obj).forEach(function (key) {
      window.localStorage.setItem(key.toUpperCase(), obj[key]);
    });
  },

  update_user_data: function (data) {
    // Save the returned information to the localStorage
    window.localStorage.setItem('IS_LOGGED_IN', 1);
    app.set_local_storage_keys(data.white_labelling);
    app.set_local_storage_keys(data);
  },

  login_success: function (data, status) {
    app.update_user_data(data);
    app.go_to_next_page();
  },

  login_error: function (xhr, status, data) {
    if (!parseInt(window.localStorage.getItem('IS_LOGGED_IN'))) {
      if (xhr.status == 401) {
        $('div.alert-danger', app.loginContent).remove();
        $('p.help-block', app.loginContent).remove();
        var error_data = $.parseJSON(data);
        $.each(error_data, function (key, value) {
          if (key == '__all__') {
            app.login_form.before(
              '<div class="alert alert-danger">' +
                                value[0] +
                            '</div>');
          } else if (key != 'success') {
            $('input[name="' + key + '"]', app.login_form).after(
              '<p class="help-block">' +
                                value[0] +
                            '</p>');
          }
        });
      } else {
        // Print all arguments to the console for debugging
        console.log(JSON.stringify(xhr));
        console.log(JSON.stringify(status));
        console.log(JSON.stringify(data));
        app.start_fresh();
      }
    }
    app.hideLoading();
  },

  // deviceready Event Handler
  //
  // The scope of 'this' is the event. In order to call the 'receivedEvent'
  // function, we must explicity call 'app.receivedEvent(...);'
  onDeviceReady: function () {
    console.log('LOG: deviceready!');

    // Set some variables/callbacks
    console.log('setting up some variables/callbacks');
    app.loginContent.hide();
    window.localStorage.setItem('IS_LOGGED_IN', this.onLoginPage ? 0 : 1);
    app.loginContent.removeClass('hide');
    app.login_form = $('#register-form', app.loginContent);
    app.showLoading();
    app.no_connection = $('#no-connection');
    app.no_connection.hide();
    app.no_connection.removeClass('hide');
    $('a.btn', app.no_connection).on('touchend', app.found_connection);
    document.addEventListener('online', app.found_connection, false);
    document.addEventListener('offline', app.lost_connection, false);
    app.run();
  },

  go_to_home: function () {
    var new_location = window.Urls['tracker.home']({}, { 'native': true });
    var site_code = window.localStorage.getItem('SITE_CODE');
    if (site_code && site_code.indexOf('mos') === 0) {
      new_location = 'mos-' + new_location;
    }
    console.log('window.location: ' + new_location);
    window.location = new_location;
  },

  go_to_next_page: function () {
    var next = window.localStorage.getItem('GO_TO_PAGE');
    console.log('go_to_next_page: ' + next);
    if (next) {
      window.localStorage.removeItem('GO_TO_PAGE');
      window.location = next;
    } else {
      app.go_to_home();
    }
  },

  found_connection: function () {
    app.no_connection.fadeOut();
    app.showLoading();
    app.run();
  },

  lost_connection: function () {
    app.showLoading();
    app.loginContent.fadeOut();
    app.no_connection.fadeIn(400, app.hideLoading);
  },

  on_push_notification_message: function (payload) {
    console.log('on_push_notification_message' + JSON.stringify(payload));
    const data = payload.additionalData;
    if ('screener_slug' in data) {
      if (app.daily_tracker) {
        // If app.daily_tracker exists, the screener modal might be ready.
        // If so, open it, otherwise wait for it to be ready
        var screener = app.daily_tracker.assessment_views[data.screener_slug];
        if (screener.modal) {
          screener.open();
        } else {
          screener.on('ready', screener.open);
        }
        // Screener already opened, we know we are on the right page, so return
        return;
      }
      // If app.daily_tracker doesn't exist, the screener is not ready
      // to open yet. Add the slug to localStorage for use later
      window.localStorage.setItem('OPEN_SCREENER', data.screener_slug);
    }
    if ('page' in data) {
      if (parseInt(window.localStorage.getItem('IS_LOGGED_IN'))) {
        window.location = data.page;
      } else {
        // When login completes, we will be sent to the payload page
        window.localStorage.setItem('GO_TO_PAGE', data.page);
      }
    }
  },

  errorHandler: function (error) {
    // Continue logging in, even when there is an error setting up push
    // notifications.
    if (app.received_regid === false) {
      app.check_login(null);
    }
    console.log(typeof error !== 'undefined' ? error : '');
  },

  onPushRegistration: function (data) {
    app.received_regid = true;
    app.check_login(data.registrationId);
  },

  run: function () {
    app.received_regid = false;

    // If we've logged in already, skip the rigamarole
    if (typeof cordova === 'undefined') {
      // If this is not phonegap, skip the push notification stuff
      app.bind_form();
      return;
    }

    console.log('LOG: registering device!');
    // First, check that we have a connection. If not, FAIL
    if (navigator.connection.type == Connection.NONE) {
      app.lost_connection();
    } else {
      // We need to call register every time to enable the event callbacks
      // so we will receive json message about notification taps. The
      // registration_id will rarely (if ever) change.
      console.log('registering for push notifications');
      const push = PushNotification.init({
        android: {},
        ios: {
          badge: 'false',
          sound: 'true',
          alert: 'true',
        },
      });
      push.on('registration', app.onPushRegistration);
      push.on('notification', app.on_push_notification_message);
      push.on('error', app.errorHandler);
    }
  },

  hideLoading: function () {
    app.loadingView.hide();
  },

  showLoading: function () {
    app.loadingView.hide();
    app.loadingView.show();
  }
});



// WEBPACK FOOTER //
// ./static/js/views/native.js